import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import { getActiveCompanySettings, logger } from '$utils'
import useWorkforceStore from '../../store'
import { AuthModule, PayrollSystem } from '$constants'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in AddStaffMember loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in AddStaffMember loader')

  const { payrollSystemPreference, hasManagerPermission } =
    getActiveCompanySettings()

  //We only need to check the connectivity if the company has XeroAu as the payroll system preference
  //because we only need the calendars and super funds which are only available for XeroAu
  const isThirdPartyPayrollSystemConnected =
    payrollSystemPreference === PayrollSystem.XeroAu &&
    (await useWorkforceStore
      .getState()
      .checkThirdPartyConnectionStatus(AuthModule.Time))

  const getPosStaffMembers = useWorkforceStore.getState().getPosStaff(false)

  const getStaffMembers = useWorkforceStore.getState().getStaffMembers(false)

  //This is only available for XeroAu, which is already taken into account
  //when checking the connectivity
  const getCalendars = isThirdPartyPayrollSystemConnected
    ? useWorkforceStore
        .getState()
        .getCalendars(payrollSystemPreference as PayrollSystem)
    : []

  //This is only available for XeroAu, which is already taken into account
  //when checking the connectivity
  const getPayrollSuperFunds =
    isThirdPartyPayrollSystemConnected && hasManagerPermission
      ? useWorkforceStore
          .getState()
          .getPayrollSuperFunds(payrollSystemPreference as PayrollSystem)
      : []

  //This is only available for XeroAu, which is already taken into account
  //when checking the connectivity
  const getEarningsRates =
    isThirdPartyPayrollSystemConnected && hasManagerPermission
      ? useWorkforceStore
          .getState()
          .getEarningsRates(payrollSystemPreference as PayrollSystem)
      : []

  const getSuperFunds = useWorkforceStore.getState().getSuperFunds()

  const getCompanyDefaultWorkingHours = useWorkforceStore
    .getState()
    .getCompanyDefaultWorkingHours()

  return defer({
    data: Promise.all([
      getPosStaffMembers,
      getStaffMembers,
      getCalendars,
      getSuperFunds,
      getPayrollSuperFunds,
      getEarningsRates,
      getCompanyDefaultWorkingHours,
    ])
      .then(() => true)
      .catch((error) => {
        logger.error('Add Staff Member Promise.all error', error)
        return false
      }),
  })
}
